﻿$.fn.dxCtrlStepperBt = function custom_dxCtrlStepperBt(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlstepperbt dx-ctrl");
        this.createInstance(new cdxCtrlStepperBt(this, option));
    }
    return this;
}

window.cdxCtrlStepperBt = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();

        var $Table = $("<table/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdFleche = null
        if (!option.value.isFirst) {
            $TdFleche = $("<td style='width:1px;padding:5px;'><i class='fas fa-arrow-right-long'></i></td>").appendTo($Tr)
        }

        var $TdBt = $("<td style='width:1px;'/>").appendTo($Tr)
        var $DivBt =$("<div/>").appendTo($TdBt)
        $DivBt.addClass("dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text")
        $DivBt.css({
            "padding": "5px",
            "text-align": "center",
            "line-height": "1",
            "height": "auto",
            "display": "inline-block"
        })
        $("<div><i class='" + option.value.icon + "' style='font-size:140%;'></i></div>").appendTo($DivBt)
        $("<div style='font-family:barlow condensed;white-space:nowrap;'>" + option.value.text + "</div>").appendTo($DivBt)


        if (option.value.isSelected) {
            $DivBt.addClass("dx-theme-accent-as-background-color")
            $DivBt.css("font-weight", "600")
        } else if (option.value.isBeforeSelected && option.value.isClickable) {
            $DivBt.css("background-color", theme.backgroundcolorAccentSelect)
            //$TdBt.css("opacity", "0.8")
        } else {
            //after select
            if (option.value.isClickable) {
                //clickable

            } else {
                //after non clickable
                $DivBt.css("opacity", "0.3")
                if ($TdFleche) $TdFleche.css("opacity", "0.3")
            }
        }

        if ($TdFleche && (option.value.isSelected || option.value.isBeforeSelected)) {
            $TdFleche.css("color", theme.backgroundcolorAccent)
        }

        if (option.value.isClickable && !option.value.isSelected) {
            $DivBt.addClass("state-hover")
            $DivBt.on("click", function (e) {
                option.onClick(option.value)
            })
        } else {
            $DivBt.css("cursor","default")
        }

    }

    this.element = function () { return container; }
    this.component = function () { return dx }

    mConstruit();
}